import React from "react";
import { connect } from "react-redux";
import Container from "../components/Container";
import SectionTitle from "../components/SectionTitle";
import ParseHTML from "../components/ParseHTML";

const Medizinische_Fachangestellte = React.createClass({
    propTypes: {
        content: React.PropTypes.string.isRequired,
    },
    render: function () {
        return (
            <Container>
                <SectionTitle>
                    Medizinische Fachangestellte (m/w/d) gesucht
                </SectionTitle>
                <div className="row">
                    <div className="col-xs-12">
                        <p>
                            <ParseHTML>{this.props.content}</ParseHTML>
                        </p>
                    </div>
                </div>
            </Container>
        );
    },
});

const mapStateToProps = (state) => {
    return {
        content: state.medizinische_fachangestellte,
    };
};

export default connect(mapStateToProps)(Medizinische_Fachangestellte);



// WEBPACK FOOTER //
// ./src/js/containers/Medizinische_Fachangestellte.js